// eslint-disable-next-line no-restricted-imports
import { useLocation } from '@remix-run/react'
import { type ComponentProps } from 'react'
import { ScrollableRestaurants } from '~/components/ScrollableRestaurants'
import { isEmpty } from '~/lib/empty'
import type { RestaurantRecommendCardFragment } from '~/lib/graphql/graphql'
import type { RestaurantId } from '~/lib/graphql/scalars'
import { bleed } from '~/styled-system/patterns'
import { Section } from './Section'

type Props = {
  data: RestaurantRecommendCardFragment[]
}

export function RecommendedRestaurants({ data }: Props) {
  // ScrollableRestaurants を利用するため、おすすめレストランを RestaurantRecommendCardFragment[] で受け取ってキャストしている
  // TODO: おすすめレストランの検索が macaron backend へ移行されたらこのキャストは削除する
  const restaurants = data as ComponentProps<typeof ScrollableRestaurants>['restaurants']
  const { search } = useLocation()
  const linkTo = (restaurantId: RestaurantId) => `/${restaurantId}${search}`
  if (isEmpty(data)) {
    return null
  }
  return (
    <Section title="おすすめレストラン">
      <div className={bleed({ inline: { _sd: '3' } })}>
        <ScrollableRestaurants restaurants={restaurants} linkTo={linkTo} />
      </div>
    </Section>
  )
}
